const PORTAL_ROUTE_ROOTS = new Set([
  "admin",
  "login",
  "forgot-password",
  "reset-password",
  "employee-management",
  "employees",
  "customer-management",
  "service-plan-management",
  "complaint-management",
  "complaints",
  "inventory-management",
  "supplier-management",
  "area-zone-management",
  "areas",
  "recovery-task-management",
  "task-management",
  "bank-management",
  "payment-management",
  "isp-payment-management",
  "billing-invoices",
  "customers",
  "reporting",
  "reporting-analytics",
  "message-management",
  "logs-management",
  "isp-management",
  "vendor-management",
  "vendors",
  "expense-management",
  "extra-income-management",
  "whatsapp",
  "profile",
  "notifications",
  "invoices",
  "customer-portal",
  "employee-portal",
])

/** True when a cold-loaded path belongs to an application portal, not marketing. */
export const isPortalApplicationPath = (pathname: string): boolean => {
  const firstSegment = pathname.trim().split("/").filter(Boolean)[0]?.toLowerCase()
  if (!firstSegment) return false
  if (firstSegment === "public" && pathname.toLowerCase().startsWith("/public/invoice/")) {
    return true
  }
  return PORTAL_ROUTE_ROOTS.has(firstSegment)
}

export const shouldUsePortalApplication = (
  pathname: string,
  hasAuthenticatedSession: boolean,
): boolean => hasAuthenticatedSession || isPortalApplicationPath(pathname)
